import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';
import { useDispatch, useSelector } from 'react-redux';

import { Avatar } from '@components/avatar';
import { logout } from '@lib/beacon';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { actions } from '@state/auth';
import { RootState } from '@state/store';
import { getURLFromIPFSorHTTP } from '@utils/ipfs';
import { testNodeHealth } from '@utils/node';

import * as Styles from './styles';

export function UserProfile() {
  const { user } = useSelector((state: RootState) => state.auth);
  const viewer = user?.id;
  const path = getURLFromIPFSorHTTP(user?.profile_image_uri);

  return <Avatar username={viewer} path={path} size={32} />;
}

export function UserMenu() {
  const t = useTranslations('header');
  const router = useRouter();
  const dispatch = useDispatch();
  const { user } = useSelector((state: RootState) => state.auth);
  const viewer = user?.id;

  const handleLogout = async () => {
    await testNodeHealth();
    await logout();
    dispatch({ type: actions.AUTH_LOGOUT });
  };

  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <Styles.Trigger>
          <UserProfile />
        </Styles.Trigger>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content asChild sideOffset={8}>
        <Styles.Content>
          <Link href={`/user/${viewer}/created`} locale={router.locale} prefetch={false} passHref>
            <a>
              <DropdownMenu.Item asChild>
                <Styles.Item>{t('profile')}</Styles.Item>
              </DropdownMenu.Item>
            </a>
          </Link>

          <Link href="/dashboard" locale={router.locale} prefetch={false} passHref>
            <a>
              <DropdownMenu.Item asChild>
                <Styles.Item>{t('dashboard')}</Styles.Item>
              </DropdownMenu.Item>
            </a>
          </Link>

          <Link href="/settings" locale={router.locale} prefetch={false} passHref>
            <a>
              <DropdownMenu.Item asChild>
                <Styles.Item>{t('settings')}</Styles.Item>
              </DropdownMenu.Item>
            </a>
          </Link>

          <DropdownMenu.Separator asChild>
            <Styles.Separator />
          </DropdownMenu.Separator>

          <DropdownMenu.Item asChild onSelect={handleLogout}>
            <Styles.Item>{t('logout')}</Styles.Item>
          </DropdownMenu.Item>
        </Styles.Content>
      </DropdownMenu.Content>
    </DropdownMenu.Root>
  );
}
